import { Avatar, Box, styled } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Card = styled(Box, {
  shouldForwardProp: (prop) => {
    return prop !== 'isInteractive';
  },
})<{ isInteractive?: boolean }>(({ isInteractive }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '20px',
    height: '100%',
    minHeight: '180px',
    minWidth: 0, // allow the card (and its text children) to shrink inside a grid track
    backgroundColor: palette.white,
    // Keeps cards visible on the white mobile page background (they're white too).
    border: `1px solid ${palette.border.default}`,
    borderRadius: '16px',
    cursor: isInteractive ? 'pointer' : 'default',
    transition: 'all 0.2s',

    // Lift only where the card is actually clickable — as a tooltip preview it must sit still.
    '&:hover': isInteractive
      ? {
          boxShadow: '0 8px 16px rgba(102, 52, 151, 0.15)',
          transform: 'translateY(-2px)',
        }
      : undefined,
  };
});

// Purple is the monogram-fallback background only; with a real logo we use white so a
// transparent PNG doesn't sit on purple (or on Avatar's default grey).
export const Logo = styled(Avatar, {
  shouldForwardProp: (prop) => {
    return prop !== 'hasImage';
  },
})<{ hasImage?: boolean }>(({ hasImage }) => {
  return {
    width: '56px',
    height: '56px',
    fontSize: '22px',
    fontWeight: 600,
    borderRadius: '12px',
    border: `1px solid ${palette.border.default}`,
    backgroundColor: hasImage ? palette.white : palette.primary.purple500,
    color: palette.white,
    // Small gap between the border and the logo image (no padding for the monogram fallback).
    '& img': {
      objectFit: 'contain',
      padding: hasImage ? '6px' : 0,
    },
  };
});

export const CardName = styled('h3')({
  margin: 0,
  fontSize: '16px',
  fontWeight: 600,
  color: palette.text.header,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const CardMeta = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginTop: 'auto',
});

export const MetaItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  fontSize: '13px',
  color: '#6B7280',
  textTransform: 'capitalize',

  '& svg': {
    fontSize: '16px',
  },
});

export const Tag = styled(Box)({
  width: 'max-content',
  maxWidth: '100%',
  color: palette.text.header,
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '136%',
  padding: '8px 12px',
  borderRadius: '24px',
  backgroundColor: palette.background.blue500,
  textTransform: 'capitalize',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
